import Card from "../Card";
import PercentChange from "../PercentChange";
import Sparkline from "../Sparkline";
import { formatMarketPrice } from "../../utils/format";

const MARKET_CURRENCIES_COLORS = {
  "btc": "#F7931A",
  "eth": "#627EEA",
  "sol": "#14F195",
  "dot": "#E6007A",
  "pepe": "#3D9E4F",
  "atom": "#6B7A65",
  "ltc": "#345D9D",
  "xlm": "#6B7A65"
};

const PricesCard = ({ data = [] }) => {
  const hasData = Array.isArray(data) && data.length > 0;
  return (
    <Card className="flex flex-col overflow-hidden p-0">
      <div className="flex h-[54px] shrink-0 items-center justify-between border-b border-divider px-4 pb-[17px] pt-4">
        <h2 className="text-base font-semibold leading-[21px] text-text-primary">
          Market prices
        </h2>
      </div>

      {hasData ? (
        <ul className="flex flex-col">
          {data.map((item, index) => (
            <li
              key={item.id}
              className={`flex min-h-[64px] items-center justify-between gap-3 px-5 pb-[11px] pt-2.5 ${
                index < data.length - 1
                  ? "border-b border-divider"
                  : "pb-0"
              }`}
            >
              <div className="flex w-[120px] shrink-0 items-center gap-2.5">
                <div
                  className="flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    className="size-6 rounded-full object-cover"
                  />
                </div>
                <p className="whitespace-nowrap text-[13px] font-semibold leading-[19.5px] text-text-primary">
                  {item.name}
                </p>
              </div>

              <div className="flex flex-1 items-center justify-center">
                <Sparkline
                  data={item.sparkline_in_7d}
                  color={MARKET_CURRENCIES_COLORS[item.symbol?.toLowerCase()] || "#9CA3AF"}
                />
              </div>

              <div className="flex shrink-0 flex-col items-end">
                <p className="whitespace-nowrap text-sm font-medium leading-[19.5px] text-text-primary">
                  {formatMarketPrice(item.current_price)}
                </p>
                <PercentChange
                  value={item.price_change_percentage_24h}
                  positive={item.price_change_percentage_24h > 0}
                />
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center py-14 px-4 text-center">
          <div className="flex size-12 items-center justify-center rounded-full bg-divider text-text-secondary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="size-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.281m5.94 2.28l-2.28 5.941"
              />
            </svg>
          </div>
          <p className="text-sm font-semibold text-text-primary">
            No market data available
          </p>
          <p className="max-w-xs text-xs text-text-secondary">
            There are currently no assets or market prices to display. Please check back later.
          </p>
        </div>
      )}
    </Card>
  );
};

export default PricesCard;